export default "__VITE_ASSET__DKBn4kAx__"